import { Alert, Stack } from '@mui/material';
import React from 'react';

const PermissionDenied = () => {
    return (
        <Stack sx={{ p: 3 }}>
            <Alert severity="warning">You do not have permission to access this section.</Alert>
        </Stack>
    );
};

export default PermissionDenied;
